<template>
  <div v-if="visible" class="full-frequency">
    <ncs-empty-result v-if="emptyResult"/>
    <div v-else class="container">
      <div class="d-flex justify-content-center mb-3">
        <b-form-checkbox v-model="showCharts" class="toggle-header" plain>{{$t('result.full_frequency.toggle-charts')}}</b-form-checkbox>
      </div>
      <div class="row" v-if="showCharts">
        <div class="col-lg-12 p-1">
          <full-frequency-result-bar-chart :frequency-per-value="resultGroups['ncs_documents.text_genre']" group="ncs_documents.text_genre"/>
        </div>
        <div class="col-lg-6 p-1">
          <full-frequency-result-pie-chart :frequency-per-value="resultGroups['ncs_documents.specialization']" group="ncs_documents.specialization"/>
        </div>
        <div class="col-lg-6 p-1">
          <full-frequency-result-pie-chart :frequency-per-value="resultGroups['ncs_documents.language']" group="ncs_documents.language"/>
        </div>
      </div>
      <div v-else class="row">
        <div class="col-lg-6 p-1">
          <ncs-full-frequency-result-table :frequency-per-value="resultGroups['ncs_documents.text_genre']"
                                           group="ncs_documents.text_genre"/>
        </div>
        <div class="col-lg-6 p-1 flex-column">
          <ncs-full-frequency-result-table :frequency-per-value="resultGroups['ncs_documents.specialization']"
                                           group="ncs_documents.specialization"/>
          <ncs-full-frequency-result-table :frequency-per-value="resultGroups['ncs_documents.language']"
                                           group="ncs_documents.language"/>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import VueApexCharts from 'vue-apexcharts'
  import Ncs from 'ncs'
  import FullFrequencyResultBarChart from './FullFrequencyResultBarChart'
  import FullFrequencyResultPieChart from './FullFrequencyResultPieChart'

  export default {
    extends: Ncs.defaultComponents.NcsFullFrequencyResult,
    components: {VueApexCharts, FullFrequencyResultBarChart, FullFrequencyResultPieChart},
    data() {
      return {showCharts: false}
    }
  }
</script>
